// extracted by mini-css-extract-plugin
export default {"melodyVideo":"fL-z","isFullWidth":"gL-z","landingPageVideo":"hL-z","play":"iL-z","iframeVideo":"jL-z","playHidden":"kL-z","fullwidth":"lL-z"};